import { mapState, mapActions, mapMutations, mapGetters } from 'vuex';
import actions from './actions';
import state from './state';
import mutations from './mutations';
import getters from './getters';

export const serviceComputed = {
	...mapState('repayMstStore', Object.keys(state)),
	...mapGetters('repayMstStore', Object.keys(getters))
};
export const serviceMethods = {
	...mapActions('repayMstStore', Object.keys(actions)),
	...mapMutations('repayMstStore', Object.keys(mutations))
};
